/**
 * counterHandles.ts
 * Counterノードの入出力ハンドルID定義
 */
export const COUNTER_TARGET_HANDLES = {
  initial: 'counter-initial',
  repeat: 'counter-repeat',
} as const;

export const COUNTER_SOURCE_HANDLES = {
  inRange: 'counter-in-range',
  done: 'counter-done',
} as const;

